<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="empruntForm" @submit="addEmprunt" :validation-schema="empruntSchema">
        <div class="row">

          <div class="col-md-4">
            <label for="dateDebut" class="form-label">Date Debut<span class="text-danger">*</span></label>
            <Field name="dateDebut" class="form-control" type="number" />
            <ErrorMessage name="dateDebut" class="text-danger" />
          </div>

          <div class="col-md-4">
            <label for="dateFin" class="form-label">Date Fin<span class="text-danger">*</span></label>
            <Field name="dateFin" class="form-control" type="number" />
            <ErrorMessage name="dateFin" class="text-danger" />
          </div>

          <div class="col-md-4">
            <label for="statut" class="form-label">Statut<span class="text-danger">*</span></label>
            <Field name="statut" class="form-control" type="text" />
            <ErrorMessage name="statut" class="text-danger" />
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black mb-10">
                Document <span class="text-danger">*</span>
              </label>
              <Field name="document" v-model="documents" type="text" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="documentOptions" :preserve-search="true"
                  :multiple="false" :searchable="true" placeholder="Sélectionner le document" label="label"
                  track-by="label" />
              </Field>
              <span class="text-danger" v-if="showMErr">Le document est obligatoire</span>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black mb-10">
                User <span class="text-danger">*</span>
              </label>
              <Field name="user" type="text" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="userOptions" :preserve-search="true"
                  :multiple="false" :searchable="true" placeholder="Sélectionner l'utilisateur" label="label"
                  track-by="label" />
              </Field>
              <ErrorMessage name="user" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center ">
              <button class="btn btn-success me-3" type="submit">
                Ajouter un emprunt
              </button>
              <router-link to="/emprunts/liste-emprunt" class=" btn btn-danger"><i
                  class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted, ref } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import axios from 'axios';
import ApiService from '@/services/ApiService';
import { Emprunt } from '@/models/Emprunt';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect/src/Multiselect';


export default defineComponent({
  name: "AddEmprunt",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },

  setup: () => {
    const empruntSchema = Yup.object().shape({
      dateDebut: Yup.string().required("La Date Debut est obligatoire."),
      dateFin: Yup.string().required("La Date Fin est obligatoire."),
      statut: Yup.string().required("Le statut est obligatoire."),
      user: Yup.string().required("L'utilisateur est obligatoire."),
      document: Yup.string().required("Le document est obligatoire."),

    });

    onMounted(() => {
      getAllDocuments();
      getAllUsers();
    });

    const empruntForm = ref(null);
    const showMErr = ref(false);
    const documents = ref();
    const userOptions = ref();
    const documentOptions = ref([]);
    const router = useRouter();


    const addEmprunt = async (values, { resetForm }) => {
      ApiService.post("/emprunts", values)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeEmpruntPage" });
          }
        }).catch(({ response }) => {
          error(response.data.message);
        });
    };

    const getAllDocuments = async () => {
      try {
        const response = await ApiService.get('/all/documents');
        const documentsData = response.data.data.data;
        documentOptions.value = documentsData.map((document) => ({
          value: document.id,
          label: document.titre,
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }

    const getAllUsers = async () => {
      try {
        const response = await ApiService.get('all/users');
        const usersData = response.data.data.data;
        userOptions.value = usersData.map((user) => ({
          value: user.id,
          label: user.nom,
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }


    return { empruntSchema, addEmprunt, empruntForm, documentOptions, showMErr, documents, userOptions };
  },
});
</script>